/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useRef, useState, ChangeEvent } from 'react';
import fileOpenImg from './dndimages/folder-icon.png';

interface DataLoaderProps {
  name: string;
  fileTypes: string;
  title?: string;
  onFileLoad: (file: File | FileList) => void;
  multiple?: boolean;
  buttonStyle?: React.CSSProperties;
  buttonClassName?: string;
}

const DataLoader: React.FC<DataLoaderProps> = ({
  name,
  fileTypes,
  title,
  onFileLoad,
  multiple = false,
  buttonStyle = {},
  buttonClassName = '',
}) => {
  const [inputKey, setInputKey] = useState(name + Date.now());
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleLoadDataClick = () => {
    // Programmatically click the hidden file input element
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) {
      return;
    }

    // Handle the selected file here (e.g., read it or upload it)
    if (multiple) {
      console.log("Selected files:", Array.from(files).map(file => file.name));
      onFileLoad && onFileLoad(files);
    } else {
      console.log("Selected file:", files[0].name);
      onFileLoad && onFileLoad(files[0]);
    }
    event.target.value = ''; // Reset the input value to allow re-uploading the same file
  };

  return (
    <span key={inputKey}>
      <input type="file"
             ref={fileInputRef}
             onChange={handleFileChange}
             style={{ display: 'none' }}
             accept={fileTypes}
             multiple={multiple}
      />
      <button onClick={handleLoadDataClick}
              style={buttonStyle} 
              className={buttonClassName}
              title={title}
              type="button">
        <img src={fileOpenImg} alt={name} width='16px' /> {name}
      </button>
    </span>
  );
}

export default DataLoader;
